import { FormField } from "../../components/FormElements/FormFieldsRenderer";

const registerPharmacy = (t, requiredFields, regionProps ) => {
  const patientFormDefinitions = [
    {
      key: 'name'
    },
    {
      key: 'address'
    }
  ];

  const formFields: FormField[] = patientFormDefinitions.map(field => {
    const { key } = field;

    return {
      label: t(`common.registrationForm.${key}`),
      prefix: 'editPharmacy',
      isRequired: requiredFields[key],
      fieldType: 'Text',
      isFullWidth: true,
      subType: 'text',
      name: key
    };
  });

  formFields.push(
    {
      label: t(`regionSelector.county`),
      prefix: 'editPharmacy',
      isRequired: true,
      regionProps: regionProps,
      name: 'region',
      fieldType: 'Region'
    },
    {
      label: t(`common.registrationForm.phone`),
      prefix: 'editPharmacy',
      isRequired: requiredFields.phone,
      fieldType: 'Text',
      isFullWidth: true,
      subType: 'text',
      name: 'phone'
    }
  );

  return formFields;
}

export default registerPharmacy;
